// Get formatted number
export const getFormattedNumber = (value) => {
  return Number(value).toFixed(2);
};
